import { render, staticRenderFns } from "./ReportEdit.vue?vue&type=template&id=38ded018&scoped=true&"
import script from "./ReportEdit.vue?vue&type=script&lang=js&"
export * from "./ReportEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReportEdit.vue?vue&type=style&index=0&id=38ded018&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ded018",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ded018')) {
      api.createRecord('38ded018', component.options)
    } else {
      api.reload('38ded018', component.options)
    }
    module.hot.accept("./ReportEdit.vue?vue&type=template&id=38ded018&scoped=true&", function () {
      api.rerender('38ded018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportEdit.vue"
export default component.exports